import { render } from "./Banner.vue?vue&type=template&id=4c1006c3&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=4c1006c3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1006c3"]])

export default __exports__